export default __webpack_public_path__ + "static/media/mechanized-farm.420a7ec1.svg";